export default "__VITE_ASSET__22eb3145__"